// Sprint F10 — Integrações externas (Conta Azul, D4 Sign, Notion, etc.)
// Entry point fino: orquestra as Tabs e delega cada integração pra um
// componente em src/pages/admin-integracoes/.
import { Typography, Tabs, App as AntApp } from 'antd';
import {
  BankOutlined, FileTextOutlined, DatabaseOutlined,
  FieldTimeOutlined, SafetyCertificateOutlined, ApiOutlined,
} from '@ant-design/icons';
import { AdminD4Sign } from './Admin';
import FinanceiroReconcileNotion from './FinanceiroReconcileNotion';
import AdminIntegracaoClockify from './AdminIntegracaoClockify';
import IntegracaoContaAzul from './admin-integracoes/IntegracaoContaAzul';
import IntegracaoInter from './admin-integracoes/IntegracaoInter';
import IntegracaoPloomes from './admin-integracoes/IntegracaoPloomes';

const { Title, Text } = Typography;

export default function AdminIntegracoes() {
  return (
    <AntApp>
      <div style={{ padding: '16px 24px', maxWidth: 1100, margin: '0 auto' }}>
        <Title level={4} style={{ margin: 0, color: '#020D7F' }}>🔌 Integrações</Title>
        <Text type="secondary" style={{ fontSize: 11, display: 'block', marginBottom: 16 }}>
          Conexões com sistemas externos. Cada aba abaixo é uma integração independente.
        </Text>
        <Tabs
          size="small"
          defaultActiveKey="conta-azul"
          items={[
            {
              key: 'conta-azul',
              label: <span><BankOutlined /> Conta Azul</span>,
              children: <IntegracaoContaAzul />,
            },
            {
              key: 'd4sign',
              label: <span><FileTextOutlined /> D4 Sign</span>,
              children: <AdminD4Sign />,
            },
            {
              key: 'notion',
              label: <span><DatabaseOutlined /> Notion</span>,
              children: <FinanceiroReconcileNotion />,
            },
            {
              key: 'clockify',
              label: <span><FieldTimeOutlined /> Clockify</span>,
              children: <AdminIntegracaoClockify />,
            },
            {
              key: 'inter',
              label: <span><SafetyCertificateOutlined /> Banco Inter</span>,
              children: <IntegracaoInter />,
            },
            {
              key: 'ploomes',
              label: <span><ApiOutlined /> Ploomes</span>,
              children: <IntegracaoPloomes />,
            },
            // Próximas integrações entram aqui: SES (envio de e-mail),
            // Telegram (bot Dwight), PNCP (sync licitações), etc.
          ]}
        />
      </div>
    </AntApp>
  );
}
